import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParseDefault } from '../Parsers/TEDParserDefault';
import { TEDTranslateValuesDisplayer } from '../Displayers/TEDTranslateValuesDisplayer';

class TEDFormatValues implements IFormatter {
  displayer = TEDTranslateValuesDisplayer.getInstance();
  parser = TEDParseDefault.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatValues };
